module.exports = __webpack_public_path__ + "static/media/logo_invert.32f02cd5.svg";